import React from 'react';
import { connect } from 'react-redux';
import { declOfNum } from '@ertelecom/ui-react/components/helpers';
import { GA } from '../../../api/channels';

import {
    Popup,
    Header,
    TariffName,
    Title,
    Body,
    Search,
    Filter,
    SearchQuery,
    ChannelsDescription,
    Result,
    ResultItems,
    Channel,
} from './styled';

const channelsText = declOfNum(['канал', 'канала', 'каналов']);

const FILTER_ALL = { value: '0', label: 'Все', name: 'Все', weight: -1 };

class PopupChannels extends React.Component {
    state = {
        selectedTheme: FILTER_ALL,
        searchString: '',
        themes: [],
    }

    searchRef = React.createRef();

    onSearch = item => {
        GA({
            action: 'Filter_сhannel',
            label: 'search',
        });

        const search = (item.title) ? item.title : this.searchRef.current.state.search;
        this.setState({ searchString: search, selectedTheme: (search === '') ? FILTER_ALL : {} });
        this.searchRef.current.clearInput();
    };

    setFilter = selected => {
        if (selected) {
            GA({
                action: 'Filter_сhannel',
                label: selected.name,
            });
        }

        this.setState({
            selectedTheme: (selected !== null) ? selected : FILTER_ALL,
            searchString: '',
        });
    }

    onScroll = () => {
        if (this.timeout) {
            clearTimeout(this.timeout);
        } else {
            document.body.click();
        }

        this.timeout = setTimeout(() => {
            this.timeout = undefined;
        }, 100);
    }

    onChannelClick = (e) => {
        GA({
            action: 'Click_сhannel',
            label: e.title,
        });
    }

    componentDidUpdate({ isOpen }) {
        if (isOpen !== this.props.isOpen && this.props.isOpen === true) {
            const filterIds = this.props.data.channels.map((channel) => channel.theme && Number(channel.theme.thid));
            const filteredThemes = this.props.themes.filter(theme => filterIds.includes(Number(theme.value)) || Number(theme.value) === 0);
            this.setState({
                themes: filteredThemes,
            });
        }
    }

    render() {
        const { isOpen, onClose, data, tarifName, channelInfo, connectedChannels } = this.props;
        const { selectedTheme, searchString, themes } = this.state;

        const channelsCountInTariff = channelInfo || 0;
        const themesOptions = [FILTER_ALL, ...themes];

        let filterResult = [];
        let filterHdCount = 0;
        if (connectedChannels) {
 filterResult = connectedChannels.filter((channel) => {
            const isSearched = (searchString === '' || channel.title.toString().toLowerCase().includes(searchString.toLowerCase()));
            const isFiltered = (Number(channel.thid) === Number(selectedTheme.value) || selectedTheme.value === '0' || !selectedTheme.value);

            if (isSearched && isFiltered) {
                if (Number(channel.hd) === 1) {
 filterHdCount += 1;
}
                return true;
            } else {
                return false;
            }
        });
}

        const searchQuery = (searchString === '') ? selectedTheme.label : `Результаты поиска «${searchString}»`;

        return (
            <Popup isOpen={isOpen} onClose={onClose} closeColor='#fff' width='calc(100vw - 300px)'>
                <Header>
                    <TariffName>{tarifName}</TariffName>
                    <Title>{`${channelsCountInTariff.total} ${channelsText(channelsCountInTariff.total)} в тарифе`}</Title>
                </Header>
                <Body>
                    <Search ref={this.searchRef} placeholder='Найдите канал' items={data.channels} onSearch={this.onSearch} />
                    <Filter options={themesOptions} onChange={this.setFilter} selected={selectedTheme}/>
                    <SearchQuery>{searchQuery}</SearchQuery>
                    <ChannelsDescription>{`${filterResult.length} (${filterHdCount}HD) ${channelsText(filterResult.length)}`}</ChannelsDescription>
                    <Result>
                        <ResultItems>
                            {filterResult && filterResult.map(channel => <Channel logoClick={this.onChannelClick} group={channel.title} key={channel.chid}  channel={{ id: channel.chid, ...channel }} />) }
                        </ResultItems>
                    </Result>
                </Body>
            </Popup>
        );
    }
}

const mapStateToProps = (state) => ({
    tarifName: state.auth.clientProducts.tariffName,
    themes: state.bundles.channelThemes,
});

export default connect(
    mapStateToProps,
)(PopupChannels);
